import { UserRoles } from '../../../utils/constants';

export const classroomPermissions = {
  'classroom.card.schedule-hours': [UserRoles.Ogma],
  'classroom.card.book-hours': [UserRoles.Student],
  'classroom.training.new-classroom': [UserRoles.Coach,UserRoles.Admin],
  'classroom.training.new-lesson': [UserRoles.Coach],
  'classroom.training.modify-lesson': [UserRoles.Coach],
};
